export class QuantilePoint {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "q",
            "baseName": "q",
            "type": "number",
            "format": "double"
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return QuantilePoint.attributeTypeMap;
    }
    constructor() {
    }
}
